// checkit.health — lightweight public-page analytics + signup attribution.
import { ckApi } from './checkitApi';

const ATTR_KEY = 'checkit:attribution';
const REF_KEY = 'checkit:ref';

// Capture a ?ref=<code> referral code from the URL so it can be attributed at sign-up.
export function captureRef() {
  if (typeof window === 'undefined') return;
  try {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) localStorage.setItem(REF_KEY, ref.slice(0, 40));
  } catch { /* ignore */ }
}

// Fire a page-view event for a public SEO page and remember it as the
// signup-attribution source (the last public page the visitor saw).
export function trackPageView(kind) {
  if (typeof window === 'undefined') return;
  captureRef();
  try {
    const path = window.location.pathname || '/';
    const referrer = document.referrer || '';
    try {
      localStorage.setItem(ATTR_KEY, JSON.stringify({ path, referrer, at: Date.now() }));
    } catch { /* ignore storage errors */ }
    ckApi.post('/checkit/track', { path, kind: kind || 'page', referrer }).catch(() => {});
  } catch { /* never let analytics break a page */ }
}

// Read the stored attribution to send with a sign-up.
export function getAttribution() {
  try {
    const base = JSON.parse(localStorage.getItem(ATTR_KEY) || 'null') || {};
    const ref = localStorage.getItem(REF_KEY) || null;
    return { ...base, ref };
  } catch { return null; }
}

// Record a click on a public-page sign-up CTA (funnel step between view and sign-up).
export function trackCtaClick(cta) {
  if (typeof window === 'undefined') return;
  try {
    const path = window.location.pathname || '/';
    ckApi.post('/checkit/track', { path, kind: 'cta', cta: cta || 'signup', referrer: document.referrer || '' }).catch(() => {});
  } catch { /* never let analytics break a click */ }
}
